module.exports = __webpack_public_path__ + "img/qu-code.beba797d.jpg";